import bem from 'utils/bem';

export const block = bem('file-size-upload-modal');
